import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NotificationModule } from '../../../../../shared/components/notification';
import { MyAssortmentHeaderComponent } from './my-assortment-header.component';

@NgModule({
  declarations: [MyAssortmentHeaderComponent],
  imports: [CommonModule, NzIconModule, NotificationModule],
  exports: [MyAssortmentHeaderComponent],
})
export class MyAssortmentHeaderModule {}
